import { type ChakraProps } from "@chakra-ui/react"
import { chakraTheme } from "../../theme/chakraTheme"

export const hStackOverlay: ChakraProps = {
  alignItems: "flex-start",
  minWidth: "279px",
  margin: "auto",
  px: "0"
}

const primaryColor: string = chakraTheme.colors.primary
export const footerContainer = {
  p: 0,
  pt: [0, 0, "8px"],
  mt: "0px",
  bg: primaryColor,
  color: "white",
  pb: [2, 2, "14px"]
}
